import { render } from "./MesinPresensi.vue?vue&type=template&id=12aa0760"
import script from "./MesinPresensi.vue?vue&type=script&lang=js"
export * from "./MesinPresensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__